import React from "react"

import ProjectSession from "../../../../model2/project/project-session"
import ProjectIconUI5 from "../../../../gd-ui/project-icon/project-icon-ui5"

type Props = {
    project         : ProjectSession

    isHighlighted   : boolean

    onClickProject? : func
}

export default class FinderProject extends React.Component<Props> {

    click = () => {
        this.onClickProject()
    }

    onClickProject = (e?: any) => {
        e && e.stopPropagation()
        const { project, onClickProject } = this.props
        if (onClickProject) onClickProject(project.id)
    }

    render() {
        const { project } = this.props;

        const classes = Classes("search-item project", {
            'is-highlighted': this.props.isHighlighted
        })

        return (
            <div className={classes}
                 onClick={this.onClickProject}>
                <ProjectIconUI5 className="search-item-icon project-icon" project={project} hint={false} colorize={false}/>
                <div className="search-item-details">
                    <div className="search-item-title">{project.name}</div>
                    <div className="search-item-arrow i5-big-angle-right"> </div>
                </div>
                <div className="cf"> </div>
            </div>
        );
    }
}